import { FC } from "react";
import { TextFormField } from "@blanket/components/formFields/FormFields";

type RegistrationContactFieldsProps = {
  namePrefix: string;
  idPrefix: string;
};

/**
 * Hvem Advokatsamfundet kontakter ved spørgsmål til registreringen. Nederst
 * efter datofelterne på alle seks blanketter, begge felter obligatoriske.
 *
 * Telefonen er `type="tel"`, ikke `type="number"`: et talfelt viser spinner-pile
 * og æder foranstillede nuller og landekode.
 */
export const RegistrationContactFields: FC<RegistrationContactFieldsProps> = ({
  namePrefix,
  idPrefix,
}) => (
  <>
    <TextFormField
      name={`${namePrefix}.contactEmail`}
      label="E-mailadresse til kontakt ved spørgsmål til registreringen"
      id={`${idPrefix}-input-contact-email`}
      isRequired
      type="email"
    />
    <TextFormField
      name={`${namePrefix}.contactPhone`}
      label="Telefonnummer til kontakt ved spørgsmål til registreringen"
      id={`${idPrefix}-input-contact-phone`}
      isRequired
      type="tel"
    />
  </>
);
